import Box from '@mui/material/Box';
import React from 'react';
import { Hue, Saturation } from 'react-color/lib/components/common';
import { ColorWrap } from 'react-color/lib/components/common/ColorWrap';

import { Pointer } from './Pointer';
import { PointerCircle } from './PointerCircle';
import { styles } from './ColorControlsModal.styles';

const picker = ({ hsl, hsv, onChange }) => (
  <>
    <Box sx={styles.saturation} data-test="color-picker">
      <Saturation hsl={hsl} hsv={hsv} pointer={PointerCircle} onChange={onChange} />
    </Box>
    <Box sx={styles.hue} data-test="color-slide">
      <Hue hsl={hsl} direction="horizontal" pointer={Pointer} onChange={onChange} />
    </Box>
  </>
);

export const CustomPicker = ColorWrap(picker);
